// extracted by mini-css-extract-plugin
export var articleBlockList = "richTextOptions-module--articleBlockList--d6860";
export var imgCtn = "richTextOptions-module--imgCtn--1dfff";
export var tableScrollWrapper = "richTextOptions-module--table-scroll-wrapper--71ba3";
export var videoCtn = "richTextOptions-module--videoCtn--48116";